$(document).ready(function () {
  // Start with all accordion content hidden
  $(".accordion-content").hide();

  $(".accordion-title").click(function () {
    var $accordionItem = $(this).closest(".accordion-item");
    var $accordionContent = $accordionItem.find(".accordion-content");

    // Close any open accordion items except the one clicked
    $(".accordion-item")
      .not($accordionItem)
      .removeClass("is-active")
      .find(".accordion-content")
      .slideUp(300);

    // Toggle the clicked accordion item
    if ($accordionItem.hasClass("is-active")) {
      $accordionItem.removeClass("is-active");
      $accordionContent.slideUp(300);
    } else {
      $accordionItem.addClass("is-active");
      $accordionContent.slideDown(300);
    }
  });
});
